import { Button, Modal } from 'antd';
import React from 'react';
import { Components } from './componentsEnum';
import { CardTextURL } from './interface';

class DeleteCardModalProps {
  cardType!: string;
  showDeleteModal!: boolean;
  changeShowDeleteModal!: (value: React.SetStateAction<boolean>) => void;
  setCardLoading!: (value: React.SetStateAction<boolean>) => void;
  changeLoadingState!: (value: React.SetStateAction<boolean>) => void;
  onDelete!: () => void;
}

export const warningText: CardTextURL = {
  [Components.EMAIL]:
    'This action permanently deletes the component. Any template that uses this component will continue to look and work the same as if it was designed independently without using a component.'
};

const DeleteCardModal: React.FC<DeleteCardModalProps> = ({
  cardType,
  showDeleteModal,
  onDelete,
  changeShowDeleteModal,
  setCardLoading,
  changeLoadingState
}): JSX.Element => {
  const onDeleteModalConfirm = (): void => {
    setCardLoading(true);
    changeShowDeleteModal(false);
    changeLoadingState(true);
    onDelete();
  };
  return (
    <Modal
      key="deleteModalConfirm"
      title="Are you sure?"
      style={{ top: '20vh' }}
      open={showDeleteModal}
      footer={[
        <Button
          data-cy="cancel"
          key="back"
          onClick={(): void => {
            changeShowDeleteModal(false);
          }}
        >
          Cancel
        </Button>,
        <Button
          data-cy="confirm"
          key={'onModalConfirm'}
          type="primary"
          htmlType="submit"
          onClick={onDeleteModalConfirm}
        >
          Yes, I am sure
        </Button>
      ]}
      onCancel={(): void => {
        changeShowDeleteModal(false);
      }}
    >
      <p data-cy="warningText">{warningText[cardType]}</p>
    </Modal>
  );
};
export default DeleteCardModal;
